const OwnerInfo = ({ ownerName, contactNo, emailID, ownerUid, profileImg }) => (
  <div className="item-info">
    <div className="owner-section">
      <div
        className="owner-avatar"
        style={profileImg ? { backgroundImage: `url(${profileImg})` } : {}}
      />
      <span className="owner-name">{ownerName}</span>
    </div>
    <h2>Owner Information</h2>
    <div className="info-row">
      <span>Contact No:</span>
      <span className="info-value">{contactNo}</span>
    </div>
    <div className="info-row">
      <span>Email ID:</span>
      <span className="info-value">{emailID}</span>
    </div>
    <div className="info-row">
      <span>ASU ID:</span>
      <span className="info-value">{ownerUid}</span>
    </div>
    <button className="contact-button">Contact Owner</button>
  </div>
);
export default OwnerInfo;
